import Vue from "vue";
import DetailTrack from "./Detail";
import VideoTrack from "./video";


Vue.directive("track-content", {
  inserted(el, binding, vnode) {
    // 获取指令参数
    let { value, arg } = binding;
  
    if (arg) {
      arg.split("-").forEach(item => {
        if (item === "detail") {
          const detailTrack = new DetailTrack();
          detailTrack.add({ el, value, vnode });
          setTimeout(() => {
            detailTrack.loadHandler();
          }, 300);
        }
      })
      
    }
  }
});